import _ from 'lodash'

/**
 * 增加代码字，json_config.i18n 的值已经在 updateTemplateConfig 时被更新了，所以只需要处理 i18nResource 中的代码字
 * @param state
 * @param {{language: {}, local: string}} param0
 */
export async function addI18nLanguage({ state, commit }, { language, local }) {
  const i18nResource = state.i18nResource
  _.each(language, (languageItem, key) => {
    // 循环新增的语言属性
    if (i18nResource[key]) {
      // 找到每一个属性在 i18nResource 中的配置
      i18nResource[key].forEach((innerItem) => {
        // 更新坑位配置的 data 属性
        innerItem.data[local] = languageItem
      })
    }
  })
  // 深拷贝i18nResource，保证其可被修改
  state.i18nResource = _.cloneDeep(i18nResource)
  commit('addPreviewLanguage', local)
}

/**
 * 删除代码字，json_config.i18n 的值已经在 updateTemplateConfig 时被更新了，所以只需要处理 i18nResource 中的代码字
 * @param state
 * @param {{language: {}}} param0
 */
export async function deleteI18nLanguage({ state, commit }, { language }) {
  const i18nResource = state.i18nResource
  _.each(i18nResource, (item) => {
    // 循环坑位
    item.forEach((innerItem) => {
      // 循环坑位里面的配置
      delete innerItem.data[language]
    })
  })
  state.i18nResource = i18nResource
  commit('removePreviewLanguage', language)
}
